import { BatchCollectConsignment } from 'types';
import { Heading, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import { ConsignmentReceipt } from './components';
import * as S from './styles';

interface CollectReceiptProps {
  name: string;
  cpf: string;
  batchCollectConsignments: BatchCollectConsignment[];
  collector?: string;
  collectionDate?: Date;
  signatureImage?: string;
}

export function CollectReceipt({
  name,
  cpf,
  collector,
  batchCollectConsignments,
  collectionDate = new Date(),
  signatureImage,
}: CollectReceiptProps) {
  const { formattedDate, hour, minute } = formatTimestamp(collectionDate);
  const productQuantity = batchCollectConsignments.length;
  const productQuantityText =
    productQuantity > 1 ? `dos ${productQuantity} pedidos` : `do pedido`;

  return (
    <S.Wrapper>
      <S.Content>
        <Heading weight={FontWeight.bold} size={FontSize.font16}>
          Comprovante de Retirada
        </Heading>

        <Text size={FontSize.font14}>
          Eu, <strong>{name}</strong>, CPF <strong>{cpf}</strong>, em nome de{' '}
          {collector}, confirmo a retirada {productQuantityText} a seguir em{' '}
          <strong>{formattedDate}</strong>, às{' '}
          <strong>
            {hour}:{minute}
          </strong>
          .
        </Text>

        <S.Consignments>
          <Heading weight={FontWeight.bold} size={FontSize.font16}>
            Lista de pedidos:
          </Heading>
          {batchCollectConsignments.map((consignment) => (
            <ConsignmentReceipt
              key={consignment.code}
              consignment={consignment}
            />
          ))}
        </S.Consignments>
      </S.Content>

      <S.SignatureContainer>
        {signatureImage && (
          <S.SignatureImageContainer>
            <img src={signatureImage} alt="Assinatura do transportador" />
          </S.SignatureImageContainer>
        )}
        <S.Signature>
          <Text size={FontSize.font16}>assinatura</Text>
        </S.Signature>
      </S.SignatureContainer>
    </S.Wrapper>
  );
}
